module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-tab', {
    attrs: {
      "tab-items": _vm.tabItems
    },
    on: {
      "itemClick": _vm.itemClickHandler
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: [_vm.isAndroid ? 'main-android' : '']
  }, [_c('keep-alive', [_c(_vm.currentView, {
    tag: "components"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ba99206","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main-view/index.vue
// module id = 1051
// module chunks = 2